export default __webpack_public_path__ + "static/media/loginout.6b78b2b2.svg";